import { JornadaDiariaQueryXor, JornadaMensalQueryXor } from '@/service/api'
import { useOutletContext } from 'react-router-dom'
import { ViewMode } from '../toggle-view'

export function useDigitacaoContext() {
    return useOutletContext<{
        view: ViewMode
        changeView: (view: ViewMode) => void
        periodo: [string, string]
        queryParams: JornadaMensalQueryXor | JornadaDiariaQueryXor
        existemFuncionarios: boolean
    }>()
}
